import React from 'react';
import { ADMIN_SCOPES } from '../../constants/admin_scope_constants';
import SubNav from '../General/SubNav';

const SUB_NAV_ITEMS = [
  { key: 'bulk', label: 'Bulk Tools', path: '/catalog-tool', exact: true, scopes: [ADMIN_SCOPES.MANAGE_CATALOG] },
  { key: 'bulk-manage', label: 'Bulk Manage', path: '/catalog-tool/bulk-manage', scopes: [ADMIN_SCOPES.MANAGE_CATALOG] },
  { key: 'explore', label: 'Explore', path: '/catalog-tool/explore', scopes: [ADMIN_SCOPES.MANAGE_CATALOG] },
  { key: 'product-sinks', label: 'Product Sinks', path: '/catalog-tool/product-sinks', scopes: [ADMIN_SCOPES.MANAGE_CATALOG] },
  { key: 'reports', label: 'Reports', path: '/catalog-tool/reports', scopes: [ADMIN_SCOPES.MANAGE_CATALOG] }
];

const CatalogToolSubNav = () => <SubNav items={SUB_NAV_ITEMS} />;

export default CatalogToolSubNav;
